/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';
import { TextArea, TextInput } from '@carbon/react';

import {
  saveElementTemplateStore,
  FIELDS_IDS
} from 'App/Pages/Diagram/features/save-element-template-configuration/save-element-template-store';

import * as Styled from './SaveElementTemplateConfig.styled';

export const TemplateDefinitionFields = observer(function TemplateDefinitionFields() {
  const { templateName, templateDescription } = saveElementTemplateStore;

  return (
    <>
      <Styled.InputContainer>
        <TextInput
          id={FIELDS_IDS.TEMPLATE_NAME}
          labelText="Name"
          enableCounter
          maxCount={255}
          invalid={saveElementTemplateStore.hasError(FIELDS_IDS.TEMPLATE_NAME)}
          invalidText={saveElementTemplateStore.getError(FIELDS_IDS.TEMPLATE_NAME)?.message}
          value={templateName}
          onChange={(event) => {
            saveElementTemplateStore.setTemplateName(event.target.value);
          }}
          onFocus={() => {
            saveElementTemplateStore.setFocusedField(FIELDS_IDS.TEMPLATE_NAME);
          }}
          onBlur={() => {
            saveElementTemplateStore.validateField(FIELDS_IDS.TEMPLATE_NAME, templateName);
          }}
        />
      </Styled.InputContainer>

      <Styled.InputContainer>
        <TextArea
          id={FIELDS_IDS.TEMPLATE_DESCRIPTION}
          labelText="Description (optional)"
          placeholder={
            templateDescription?.trim().length > 0
              ? templateDescription
              : 'Enter a description to let users know what this template enables them to do'
          }
          value={templateDescription}
          onChange={(event) => {
            saveElementTemplateStore.setTemplateDescription(event.target.value);
          }}
          onFocus={() => {
            saveElementTemplateStore.setFocusedField(FIELDS_IDS.TEMPLATE_DESCRIPTION);
          }}
        />
      </Styled.InputContainer>
    </>
  );
});
